import React, { useState } from "react";
import Main from "./components/Main/Main";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

const Home = () => {
  const [isPopup, setIsPopup] = useState(false); // Popup 상태 관리

  const handleBannerClose = () => {
    setIsPopup(true); // Popup 상태를 true로 변경
  };

  return (
    <>
      <Header onBannerClose={handleBannerClose} />
      <Main isPopup={isPopup} />
      <Footer />
    </>
  );
};

export default Home;
